<template>
  <div id="login">
    <div class="content bg-black middle login-box">
      <div class="cell">
        <div class="container">
          <div class="row">
            <div class="col-xs-6">
              <div class="text-center inlineb">
                <img src="../assets/images/logo_login.svg" alt />
                <!-- <p class="sub-title white mt50">PARTNER NETWORK</p> -->
              </div>
            </div>
            <div class="col-xs-6">
              <p class="sub-title white text-center">Login</p>
              <form class="form-horizontal font12 mt50">
                <div class="form-group">
                  <label for="inputEmail3" class="col-sm-4 control-label white">Email</label>
                  <div class="col-sm-8">
                    <el-input v-model="email" placeholder="Email"></el-input>
                  </div>
                </div>
                <div class="form-group has-feedback">
                  <label for="inputPassword" class="col-sm-4 control-label white">Password</label>
                  <div class="col-sm-8">
                    <el-input placeholder="Password" v-model="password" show-password></el-input>
                  </div>
                </div>
                <div class="form-group">
                  <div class="col-sm-12">
                    <div class="mt20">
                      <el-checkbox v-model="remember" class="white">Remember me</el-checkbox>
                    </div>
                    <p class="mt20">
                      <a class="white" href="#/password">Forgot your password?</a>
                    </p>
                  </div>
                </div>
                <div class="form-group mt50">
                  <div class="col-xs-12">
                    <el-button class="button2 mr30" @click="login()">LOGIN</el-button>
                    <!-- <el-button class="button2" @click="signup()">SIGN UP</el-button> -->
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="nav-footer white font16">
      <!-- <span class="orange click inlineb w10" @click="signup()">SIGN UP</span>
      <span class="orange click inlineb w10" @click="login()">LOGIN</span> -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import "../assets/css/login.css";
export default {
  name: "login",
  data() {
    return {
      email: "",
      password: "",
      remember: false
    };
  },
  methods: {
    signup() {
      this.$router.push({ path: "/signup" });
    },
    rememberedLogin() {
      axios
        .post("/login", {
          token: this.$cookies.get('remember_me_token')
        })
        .then(res => {
          if (typeof res.data._id != 'undefined') {
            if (res.data.type == "pending") {
              this.$router.push({ path: "/login" });
            } else {
              this.$message({
                type: "success",
                message: "Welcome Back!"
              });
              this.$store.state.user = res.data;
              this.$router.push({ path: "/dashboard" });
            }
          }
        })
        .catch(function (error) {

          alert(error);
        });
    },
    login() {
      axios
        .post("/login", {
          email: this.email,
          password: this.password,
          remember_me: this.remember
        })
        .then(res => {
          if (typeof res.data != 'undefined' && typeof res.data._id != 'undefined') {
            if (res.data.type == "pending") {
              alert("Your account is waiting for approval");
              this.$router.push({ path: "/login" });
            } else {
              this.$message({
                type: "success",
                message: "Welcome Back!"
              });
              if (res.data.token) {
                this.$cookies.set("remember_me_token", res.data.token, Infinity);
              }
              this.$store.state.user = res.data;

              var user = "user";
              if (this.$store.state.user) {
                user = this.$store.state.user.title + " " + this.$store.state.user.last_name
              }
              if (this.browserDetect() != 'chrome') {
                alert("Dear " + user + ", this tool is optimized for the latest browser version of Chrome. Using a different browser some functions might not work properly.")
              }

              this.$router.push({ path: "/dashboard" });
            }
          } else {
            this.$message({
              type: "error",
              message: "Wrong Password or Email"
            });
          }
        })
        .catch(function (error) {
          if (error.response.data.suspended) {
            const h = window.app.__vue__.$createElement;
            window.app.__vue__.$msgbox({
              title: "Your account is suspended!",
              message: h("p", null, [
                h(
                  "span",
                  null,
                  "Dear " +
                  error.response.data.userName +
                  ","
                ),
                h(
                  "br"
                ),
                h(
                  "span",
                  null,
                  "Your account has been suspended. Please contact our Sales Team at sales@blacknova.co for further information."
                ),
                h(
                  "br"
                ),
                h(
                  "span",
                  null,
                  "Best regards"
                ),
              ]),
            })
              .then(() => {
                this.$refs.projectForm.showModal(this.project);
              })
              .catch(() => { });

          } else {
            alert(error);
          }
        });
    },
    browserDetect() {
      let userAgent = navigator.userAgent;
      let browserName;

      if (userAgent.match(/chrome|chromium|crios/i)) {
        browserName = "chrome";
      } else if (userAgent.match(/firefox|fxios/i)) {
        browserName = "firefox";
      } else if (userAgent.match(/safari/i)) {
        browserName = "safari";
      } else if (userAgent.match(/opr\//i)) {
        browserName = "opera";
      } else if (userAgent.match(/edg/i)) {
        browserName = "edge";
      } else {
        browserName = "No browser detection";
      }

      return browserName;
    },
    loginOnEnterKey(e) {
      var keycode = document.all ? e.keyCode : e.which;
      if (keycode == 13) {
        this.login();
        return false;
      }
    }
  },
  created: function () {
    this.$parent.headerBg();
    if (this.$cookies.isKey('remember_me_token')) {
      this.rememberedLogin();
    }

    document.addEventListener('keydown', this.loginOnEnterKey);
  },
  mounted() {
    if (this.$store.state.user != null) {
      this.$router.push({ name: 'dashboard' });
    }
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.loginOnEnterKey);
  }
};
</script>

<style></style>
